var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.1818L11.7273 14.4546L9.54545 12.2727L6.27273 15.5455",
    stroke: "#222222",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 4.63635H6.49091C5.26898 4.63635 4.65801 4.63635 4.19129 4.87416C3.78076 5.08333 3.44698 5.41711 3.2378 5.82765C3 6.29436 3 6.90533 3 8.12726V17.5091C3 18.731 3 19.342 3.2378 19.8087C3.44698 20.2192 3.78076 20.553 4.19129 20.7622C4.65801 21 5.26898 21 6.49091 21H15.8727C17.0947 21 17.7056 21 18.1723 20.7622C18.5829 20.553 18.9167 20.2192 19.1258 19.8087C19.3636 19.342 19.3636 18.731 19.3636 17.5091V10.0909",
    stroke: "#222222",
    strokeWidth: 1.09091,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2727,
    cy: 5.72727,
    r: 2.18182,
    stroke: "#222222",
    strokeWidth: 1.09091,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPinLight);
export default __webpack_public_path__ + "static/media/Chart_pin_light.ced7541f840e0b7ee15268bbe47b618e.svg";
export { ForwardRef as ReactComponent };